import Icon from '../components/Icon.vue'

Icon.register({
  'fire-alt': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M323.6 51.2C302.8 70.5 284 90.8 267.3 111.2 240.1 73.6 206.3 35.5 168 0 69.7 91.2 0 210 0 281.6 0 408.9 100.3 512 224 512S448 408.9 448 281.6C448 228.3 396 118.5 323.6 51.2zM304.1 391.9C282.4 407 255.7 416 226.9 416 154.7 416 96 368.3 96 290.8 96 252.1 120.3 218.1 168.8 160 175.7 168 267.6 285.3 267.6 285.3L326.3 218.5C330.4 225.3 334.2 232 337.5 238.4 364.9 290.6 353.3 357.4 304.1 391.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/fire-alt.js
// module id = 55By
// module chunks = 144